import { render, staticRenderFns } from "./DhmeAssemblyHallDashboardTrestles.vue?vue&type=template&id=1b9d6341&scoped=true"
import script from "./DhmeAssemblyHallDashboardTrestles.vue?vue&type=script&lang=js"
export * from "./DhmeAssemblyHallDashboardTrestles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9d6341",
  null
  
)

export default component.exports